import map from 'lodash.map';
import React from 'react';
import SwiperCore, { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { INewsData, INewsItem } from 'constants/types';
import Loader from 'components/Loader/Loader';
import NewsCard from 'components/News/card/NewsCard';
import get from 'lodash.get';
import { NewsSliderWrapInline, NewsSliderWrapMain } from './NewsSliderMainStyles';

const settingsMain = {
  spaceBetween: 24,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerGroup: 1,
  autoplay: false,
  centeredSlides: false,
  scrollbar: {
    draggable: true,
  },
  watchSlidesVisibility: true,
  preloadImages: false,
  breakpoints: {
    500: {
      spaceBetween: 24,
      slidesPerView: 2,
      slidesPerColumn: 1,
      slidesPerGroup: 1,
    },
    768: {
      spaceBetween: 24,
      slidesPerView: 3,
      slidesPerColumn: 2,
      slidesPerGroup: 1,
    },
    900: {
      spaceBetween: 24,
      slidesPerView: 4,
      slidesPerColumn: 2,
      slidesPerGroup: 1,
    },
    1100: {
      spaceBetween: 24,
      slidesPerView: 5,
      slidesPerColumn: 2,
      slidesPerGroup: 1,
    },
    1300: {
      spaceBetween: 24,
      slidesPerView: 6,
      slidesPerColumn: 2,
      slidesPerGroup: 1,
    },
    1440: {
      spaceBetween: 24,
      slidesPerView: 7,
      slidesPerColumn: 2,
      slidesPerGroup: 1,
    },
  },
};
const settingsInline = {
  spaceBetween: 24,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerGroup: 1,
  autoplay: false,
  centeredSlides: false,
  scrollbar: {
    draggable: true,
  },
  watchSlidesVisibility: true,
  preloadImages: false,
  breakpoints: {
    500: {
      spaceBetween: 24,
      slidesPerView: 2,
    },
    768: {
      spaceBetween: 24,
      slidesPerView: 3,
    },
    900: {
      spaceBetween: 24,
      slidesPerView: 4,
    },
    1100: {
      spaceBetween: 24,
      slidesPerView: 5,
    },
    1300: {
      spaceBetween: 24,
      slidesPerView: 6,
    },
    1440: {
      spaceBetween: 24,
      slidesPerView: 7,
    },
  },
};

// Interfaces
interface INewsSliderMain {
  data: INewsData
  loading?: boolean
  type?: NewsSliderMainType
}

export enum NewsSliderMainType {
  MAIN = 'MAIN',
  INLINE = 'INLINE',
}

// Swiper
SwiperCore.use([Scrollbar]);

// Component
const NewsSliderMain = (props: INewsSliderMain) => {
  const { data = [], loading = false, type = NewsSliderMainType.MAIN } = props;

  const isMain = type === NewsSliderMainType.MAIN;

  const settings = isMain ? settingsMain : settingsInline;

  const Wrap = isMain ? NewsSliderWrapMain : NewsSliderWrapInline;

  if (loading) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  if (Array.isArray(data) && JSON.stringify(data) && !loading) {
    return (
      <Wrap>
        <Swiper {...settings}>
          {map(data, (item: INewsItem) => {
            const id = get(item, ['id']);

            return (
              <SwiperSlide key={id}>
                <NewsCard
                  item={item}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Wrap>
    );
  }
  return null;
};

NewsSliderMain.defaultProps = {
  loading: false,
  type: NewsSliderMainType.MAIN,
};

export default NewsSliderMain;
